import configuration from "@emcm-ui/utility-configuration";

export default displayName => {
  if (configuration.current.styles.namespace) {
    return `${configuration.current.styles.namespace}-${displayName}`;
  }

  return displayName;
};
